import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { stages } from 'bundles/apex/deals/config';

import './styles.scss';

export default function StagePip({ className, stage }) {
  return <span className={classNames('apex-deal-stage-pip', className, stage)} />;
}

StagePip.propTypes = {
  className: PropTypes.string,
  stage: PropTypes.oneOf(Object.keys(stages)),
};
